import { FC } from 'react';

import { VisuallyHidden } from '@purpur/library';
import { Icon } from '@purpur/library/icon';
import { chevronLeft } from '@purpur/library/icon/assets/chevron-left';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { withParams } from '@telialt/utils/src/helpers';

import { NAVIGATION_TEST_IDS } from '../../test-ids';
import { MobileMenuItemContainer, SelectedItemTitle, StyledMenuButton } from './MobileMenu.styles';

type Props = {
    selectedItemTitle?: string;
    onBackClick: () => void;
};

export const MobileMenuTitle: FC<Props> = ({ selectedItemTitle, onBackClick }) => {
    const { t } = useTranslations();

    return (
        <>
            <div aria-live="polite">
                {selectedItemTitle ? (
                    <VisuallyHidden>
                        {withParams(t['navbar.mobile_menu.title_submenu'], { title: selectedItemTitle })}
                    </VisuallyHidden>
                ) : (
                    <VisuallyHidden>{t['navbar.mobile_menu.title_main']}</VisuallyHidden>
                )}
            </div>
            {selectedItemTitle && (
                <MobileMenuItemContainer>
                    <StyledMenuButton
                        onClick={onBackClick}
                        data-test={NAVIGATION_TEST_IDS.MOBILE_MENU_GO_BACK_BUTTON}
                        aria-label={t['navbar.mobile_menu.submenu_go_back']}
                    >
                        <Icon svg={chevronLeft} size="md" />
                        <SelectedItemTitle data-test={NAVIGATION_TEST_IDS.MOBILE_MENU_TITLE}>
                            {selectedItemTitle}
                        </SelectedItemTitle>
                    </StyledMenuButton>
                </MobileMenuItemContainer>
            )}
        </>
    );
};
